import { all } from "redux-saga/effects";
import storeSaga from "../features/store-locations/duck/StoreSaga";
import citySaga from "../features/store-locations/duck/CitySaga";

function* rootSaga() {
  yield all([storeSaga(), citySaga()]);
}

export default rootSaga;
